<template>
    <LoadingCard v-if="loading || accessBlocked"></LoadingCard>
    <div v-else>
        <CreateSprayDiary :userId="userId" :logId="logId" :cropTypeId="cropTypeId" :growerId="growerId" :blocks="availableBlocks" />
    </div>
</template>

<script>
import findSprayLogQuery from '@views/SprayDiary/Container/queryFindSprayLog.graphql';
import currentUserQuery from '@views/SprayDiary/Create/queryCurrentUser.graphql';
import findBlockQuery from '@views/SprayDiary/Create/queryFindBlock.graphql';
import listBlocksQuery from '@views/SprayDiary/Create/queryListBlocks.graphql';

import CreateSprayDiary from './Create';

export default {
  name: 'CreateSprayDiaryContainer',
  props: ['blockId', 'cropTypeId', 'logId', 'growerId'],
  components: {
    CreateSprayDiary,
  },
  apollo: {
    currentUser: {
      query: currentUserQuery,
    },
    currentLog: {
      query: findSprayLogQuery,
      update: data => data.findSprayLog,
      variables() {
        return {
          input: {
            id: this.logId,
          },
        };
      },
      skip() {
        return !this.logId;
      },
    },
    selectedBlock: {
      query: findBlockQuery,
      variables() {
        return {
          input: {
            id: this.requestedBlockId,
          },
        };
      },
      skip() {
        return !this.requestedBlockId;
      },
      update: data => data.findBlock,
    },
    userBlocks: {
      query: listBlocksQuery,
      variables() {
        return {
          input: {
            crop_type_id: this.cropTypeId,
            sort: {
              direction: 'DESC',
              field: 'name',
            },
          },
        };
      },
      skip() {
        return this.growerId || !!this.requestedBlockId;
      },
      update: data => data.filterBlocks.data,
    },
    growerBlocks: {
      query: listBlocksQuery,
      manual: true,
      result({ loading, data }) {
        if (!loading) {
          this.userBlocks = data.filterBlocks.data;
        }
      },
      variables() {
        return {
          input: {
            user_id: this.growerId,
            sort: {
              direction: 'DESC',
              field: 'name',
            },
          },
        };
      },
      skip() {
        return !this.growerId;
      },
    },
  },
  watch: {
    currentUser() {
      const validRole = ['grower', 'contractor'].includes(this.currentUser.role.name);
      const blockAccess = () => {
        this.accessBlocked = true;
        this.$notifyFailure('Not allowed.');
        setTimeout(() => this.$router.push({ name: 'dashboard' }), this.$redirectTimeout);
      };

      if (!validRole) return blockAccess();

      if (this.currentUser.role.name === 'contractor') {
        if (!(this.blockId || this.logId || this.growerId)) return blockAccess();
        if (this.currentLog && this.currentLog.creator_id !== this.currentUser.id) return blockAccess();
      }
    },
  },
  data() {
    return {
      currentUser: null,
      currentLog: null,
      selectedBlock: null,
      accessBlocked: false,
      userBlocks: [],
      loading: 0,
    };
  },
  computed: {
    requestedBlockId() {
      return this.blockId || this.$path.get(this.currentLog, 'block_id');
    },
    availableBlocks() {
      return this.selectedBlock ? [this.selectedBlock] : this.userBlocks;
    },
    userId() {
      if (this.currentUser.role.name === 'contractor') {
        if (this.growerId) {
          return this.growerId;
        } else if (this.selectedBlock) {
          return this.selectedBlock.user_id;
        } else {
          return this.$path.get(this.availableBlocks, '0.user_id');
        }
      }
    },
  },
};
</script>
